module.exports = __webpack_public_path__ + "static/media/Extruder.7e00bb7f.png";